import React from 'react';

const GeodezijaMenu = ({ onClose, onNavigate }) => {
  const menuItems = [
    { id: 1, label: 'GPS', icon: '📡' },
    { id: 2, label: 'Stanica', icon: '📐' },
    { id: 3, label: 'Skener', icon: '📷' },
    { id: 4, label: 'Nivelir', icon: '📏' },
    { id: 5, label: 'Dron', icon: '🚁' },
    { id: 6, label: 'Tableti', icon: '📱' }
  ];

  const handleItemClick = (item) => {
    if (item.label === 'GPS') {
      onClose(); // Close the side menu
      onNavigate('gps-tracking'); // Navigate to GPS tracking screen
    } else {
      // Placeholder for other items
      console.log('Geodezija item clicked:', item.label);
    }
  };

  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 999,
          animation: 'fadeIn 0.3s ease'
        }}
      />
      
      {/* Side Menu */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100vh',
          width: '300px',
          backgroundColor: 'white',
          boxShadow: '2px 0 10px rgba(0, 0, 0, 0.1)',
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          animation: 'slideIn 0.3s ease',
          overflowY: 'auto'
        }}
      >
        {/* Header */}
        <div style={{
          padding: '20px',
          background: 'linear-gradient(135deg, #6C8B58 0%, #8BA888 100%)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 'bold' }}>Geodezija</h2>
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              border: 'none',
              color: 'white',
              fontSize: '1.5rem',
              cursor: 'pointer',
              padding: '5px 15px',
              borderRadius: '5px',
              fontWeight: 'bold',
              transition: 'background 0.3s ease'
            }}
            onMouseOver={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
            onMouseOut={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
          >
            ×
          </button>
        </div>

        {/* Menu Items */}
        <div style={{
          flex: 1,
          padding: '20px 0'
        }}>
          {menuItems.map((item, index) => (
            <button
              key={item.id}
              onClick={() => handleItemClick(item)}
              style={{
                width: '100%',
                padding: '20px',
                border: 'none',
                borderBottom: '1px solid #e1e5e9',
                background: 'white',
                textAlign: 'left',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                fontSize: '1.1rem',
                color: '#333',
                transition: 'all 0.3s ease',
                backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#6C8B58';
                e.target.style.color = 'white';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = index % 2 === 0 ? '#f8f9fa' : 'white';
                e.target.style.color = '#333';
              }}
            >
              <span style={{ fontWeight: '500' }}>{item.label}</span>
            </button>
          ))}
        </div>

        {/* Footer */}
        <div style={{
          padding: '15px 20px',
          borderTop: '1px solid #e1e5e9',
          textAlign: 'center',
          color: '#666',
          fontSize: '0.9rem'
        }}>
          © 2025 ZZF
        </div>
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(-100%);
          }
          to {
            transform: translateX(0);
          }
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </>
  );
};

export default GeodezijaMenu;
